<script>
    export default {
        props: {
            dataCount: {
                type: Number,
                default: 0,
                required: true
            },
            viewURL: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            }
        }
    };
</script>


<template>
    <div class="col-md-3">
        <div class="card mini-stats-wid">
            <a :href="viewURL">
                <div class="card-body">
                    <div class="d-flex">
                        <div class="flex-grow-1">
                            <p class="text-muted fw-medium">{{ title }}</p>
                            <h4 class="mb-0">
                                {{ dataCount }}
                            </h4>
                        </div>

                        <div class="flex-shrink-0 align-self-center ">
                            <div class="avatar-sm rounded-circle bg-primary mini-stat-icon">
                                <span class="avatar-title rounded-circle bg-primary" v-html="icon">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>